"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../static/icons/icons");

var _palette = require("../../../styles/palette");

var _style = require("./style");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BagSelector = function (_PureComponent) {
  (0, _inherits2["default"])(BagSelector, _PureComponent);

  var _super = _createSuper(BagSelector);

  function BagSelector(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, BagSelector);
    _this = _super.call(this, props);

    _initialiseProps.call((0, _assertThisInitialized2["default"])(_this));

    _this.state = {
      value: props.value || props.min
    };
    return _this;
  }

  (0, _createClass2["default"])(BagSelector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          max = _this$props.max,
          min = _this$props.min,
          passenger = _this$props.passenger,
          width = _this$props.width;
      var value = this.state.value;
      var isMinValue = value === min;
      var isMaxValue = value === max;
      var iconColor = _palette.palette.bobBlack;
      if (isMaxValue) iconColor = _palette.palette.lightGrey;
      if (error) iconColor = _palette.palette.error;
      return _react["default"].createElement(_style.Container, {
        width: width
      }, passenger && _react["default"].createElement(_style.Passenger, null, passenger), _react["default"].createElement(_style.Selector, null, _react["default"].createElement(_style.IconStyled, {
        color: isMinValue ? _palette.palette.lightGrey : _palette.palette.bobBlack,
        disabled: isMinValue,
        handleClick: this.removeBag,
        icon: _icons.ICONS.MINUS,
        size: 24,
        testId: "removeBagButton"
      }), _react["default"].createElement("span", {
        "data-test-id": "bagValue",
        className: "notranslate"
      }, value), _react["default"].createElement(_style.IconStyled, {
        color: iconColor,
        disabled: isMaxValue,
        error: error,
        handleClick: this.addBag,
        icon: _icons.ICONS.PLUS,
        size: 24,
        testId: "addBagButton"
      })));
    }
  }]);
  return BagSelector;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.addBag = function () {
    _this2.setState(function (prevState, props) {
      var value = prevState.value + 1 < props.max ? prevState.value + 1 : props.max;
      if (props.handleValue) props.handleValue(value);
      return {
        value: value
      };
    });
  };

  this.removeBag = function () {
    _this2.setState(function (prevState, props) {
      var value = prevState.value - 1 > props.min ? prevState.value - 1 : props.min;
      if (props.handleValue) props.handleValue(value);
      return {
        value: value
      };
    });
  };
};

BagSelector.propTypes = {
  error: _propTypes["default"].bool,
  handleValue: _propTypes["default"].func.isRequired,
  max: _propTypes["default"].number,
  min: _propTypes["default"].number,
  passenger: _propTypes["default"].string,
  value: _propTypes["default"].number,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
BagSelector.defaultProps = {
  error: false,
  max: 99,
  min: 1,
  passenger: null,
  width: null,
  value: null
};
var _default = BagSelector;
exports["default"] = _default;